import { useCallback } from 'react';

export const useAutoFocus = () => {
  return useCallback((inputElement) => {
    inputElement?.focus();
  }, []);
};
